import { Route, Routes } from 'react-router-dom';
import Login from '../pages/Home/Login';
import { CreateOrg } from '../pages/CreateOrganization/CreateOrg';
import { OrgView } from '../pages/OrgView/OrgView';
import { CreateUser } from '../pages/CreateUser/CreateUser';
import { OrgHome } from '../pages/Home/OrgHome';
import UserListDashboard from '../pages/UserListDashboard/UserListDashboard';
import LegacyUserListRedirect from '../pages/UserListDashboard/LegacyUserListRedirect';
import UserProfile from '../pages/UserProfile/UserProfile';
import { AppLayout } from '../layout/AppLayout';
import GlobalSearch from '../pages/GlobalSearch/GlobalSearch';
import Notifications from '../pages/Notifications/Notifications';
import Organizations from '../pages/Organizations/Organizations';
import OrgUsers from '../pages/Organizations/OrgUsers';
import SupportDebug from '../pages/SupportDebug/SupportDebug';


export function Menu() {
    return (
        <Routes>
            {/* Public routes - no authentication required */}
            <Route path="/" element={<Login />} />
            
            {/* Protected routes - wrapped in layout with sidebar */}
            <Route path="/*" element={<AppLayout />}>
                {/* Organization routes with optional orgId parameter */}
                <Route path="org-home" element={<OrgHome />} />
                <Route path="org-home/:orgId" element={<OrgHome />} />
                
                <Route path="org-view" element={<OrgView />} />
                <Route path="org-view/:orgId" element={<OrgView />} />

                {/* Revamped organization list (ADM-6); replaces org-view once fully developed */}
                <Route path="organizations" element={<Organizations />} />
                <Route path="organizations/:orgId" element={<Organizations />} />
                {/* Org-scoped user list (ADM-5) */}
                <Route path="organizations/:orgId/users" element={<OrgUsers />} />
                
                {/* Global user list across all orgs (ADM-89); the old org-scoped URL
                    redirects to the hierarchy's user list (ADM-5) */}
                <Route path="user-list-dashboard" element={<UserListDashboard />} />
                <Route path="user-list-dashboard/:orgId" element={<LegacyUserListRedirect />} />

                <Route path="notifications" element={<Notifications />} />
                <Route path="notifications/:orgId" element={<Notifications />} />

                <Route path="create-org" element={<CreateOrg />} />
                <Route path="create-org/:orgId" element={<CreateOrg />} />
                
                <Route path="create-user" element={<CreateUser />} />
                <Route path="create-user/:orgId" element={<CreateUser />} />
                
                {/* User profile with required parameters */}
                <Route path="user-profile/:orgId/:userId" element={<UserProfile />} />

                {/* Global Search */}
                <Route path="search" element={<GlobalSearch />} />

                {/* Product Support (ENG-7614) — Super Admin debug tools */}
                <Route path="support-debug" element={<SupportDebug />} />
            </Route>
        </Routes>
    )
}
export default Menu;